var tipInWin;

tipInWin = function() {
  var $, module, moduleName;
  moduleName = 'tip-in-win';
  $ = require('jquery');
  module = $("." + moduleName);
  if (module.length < 1) {
    return false;
  }
  return module.each(function() {
    var cell, tips;
    module = $(this);
    tips = module.find("." + moduleName + "__vars [data-tip]");
    cell = module.find("." + moduleName + "__cell");
    return tips.mouseenter(function() {
      var that, tiptxt;
      that = $(this);
      tiptxt = that.data('tip');
      return cell.html(tiptxt);
    });
  });
};

module.exports = tipInWin;
